import React from 'react';
import styled from 'styled-components';
import Navbar from "../components/Navbar";
import Announcement from "../components/Announcement";
import Products from "../components/Products";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import {mobile} from "../responsive";
import { useLocation } from 'react-router-dom';
import { useState } from "react";

const Container=styled.div`
`;

const Title=styled.h1`
margin:20px;
`;

const FilterCointainer=styled.div`
display:flex;
justify-content:space-between;
`;

const Filter=styled.div`
margin:20px;

 ${mobile({margin:"0px 20px",display:"flex",flexDirection:"column"})}
`;

const FilterText=styled.span`
font-size:20px;
font-weight:600;
margin-right:20px;

 ${mobile({marginRight:"0px"})}
`;

const Select=styled.select`
padding:10px;
margin-right:20px;

 ${mobile({margin:"10px 0px"})}
`;

const Option=styled.option`
`;






 function ProductList() {

   const location=useLocation();
   const cat= location.pathname.split("/")[2];


   const [filters,setFilter]=useState({});
   const [sort,setSort]=useState("newest");
   const handleFilters =(e) =>{
     const value=e.target.value;
     setFilter({
       ...filters,
       [e.target.name]:value
     });
   };

  let uppercasetext = cat.toUpperCase(); //To convert Upper Case

  return (
    <Container>
     <Announcement/>
     <Navbar/>
     <Title>{uppercasetext}</Title>
     <FilterCointainer>
            <Filter>
                  <FilterText>Filter Products:</FilterText>
                  <Select name="color" onChange={handleFilters}>
                     <Option disabled >Color</Option>
                     <Option>White</Option>
                     <Option>Black</Option>
                     <Option>Red</Option>
                     <Option>Blue</Option>
                     <Option>Yellow</Option>
                     <Option>Green</Option>
                     <Option>Gray</Option>
                     <Option>Pink</Option>
                     <Option>Brown</Option>
                  </Select>
                  <Select name="size" onChange={handleFilters}>
                     <Option disabled>Size</Option>
                     <Option>XS</Option>
                     <Option>S</Option>
                     <Option>M</Option>
                     <Option>L</Option>
                     <Option>XL</Option>
                  </Select>
            </Filter>
            <Filter>
                <FilterText>Sort Products:</FilterText>
                <Select name="size" onChange={(e)=>setSort(e.target.value)}>
                   <Option value="newest">Newest</Option>
                   <Option value="asc">Price (asc)</Option>
                   <Option value="desc">Price (desc)</Option>
                </Select>

            </Filter>
     </FilterCointainer>

     <Products all="no" cat={cat} filter={filters} sort={sort}/>
     <Newsletter/>
     <Footer/>



    </Container>
  );
}

export default ProductList;
